import c from "axios";
import { g as u } from "./tokens-C4KyVSzL.js";
function f(i, n) {
  i.interceptors.request.use((e) => {
    const s = u();
    return s && e.headers.set("Authorization", `Bearer ${s}`), e;
  }), i.interceptors.response.use(
    (e) => e,
    async (e) => {
      var o;
      const s = (o = e == null ? void 0 : e.response) == null ? void 0 : o.status, t = e == null ? void 0 : e.config;
      if (s !== 401 || !t)
        return Promise.reject(e);
      if (t._retry)
        return await n.login(), Promise.reject(e);
      t._retry = !0;
      const a = await n.updateToken();
      return a ? c.request({
        ...t,
        headers: {
          ...t.headers,
          Authorization: `Bearer ${a}`
        }
      }) : (await n.login(), Promise.reject(e));
    }
  );
}
export {
  f as attachAuthInterceptors
};
//# sourceMappingURL=axios.es.js.map
